import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ReducersTypes } from "@/redux/reducers/Models";
import { getMaskedCardNumber } from "@/utils/transform";
import { useSingleCardBrand } from "@/hooks/useCardBrands";

export default function DirectPaymentFooter() {
  const navigate = useNavigate();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);
  const { brand } = useSingleCardBrand(customer?.account?.card?.id || "");

  const isDirectPaymentEnabled = customer?.account?.paymentMode === "2";

  const hasCard =
    customer?.account?.card?.id && customer?.account?.card?.cardNumber;

  if (!isDirectPaymentEnabled || !hasCard) {
    return null;
  }

  const cardNumber = getMaskedCardNumber(
    customer?.account?.card?.cardNumber || "",
  );
  const cardBrand = brand?.descricaoBandeira?.toLowerCase() || "";

  const handleClick = () => {
    navigate("/mycards");
  };

  return (
    <div
      className="fixed bottom-0 left-1/2 -translate-x-1/2 z-10 bg-white w-[calc(480px)] max-w-[calc(96%)] shadow-md rounded-t-xl p-4 min-h-[70px] transition-all duration-300 ease-in-out cursor-pointer hover:shadow-lg"
      onClick={handleClick}
    >
      <div className="w-full flex justify-between items-center">
        <div className="">
          <span className="bg-black text-white text-xs px-2 py-1 rounded-md inline-block mb-3">
            Pagamento direto ativo
          </span>
          <div className="flex flex-row">
            <div className="mr-3">
              <div className="flex items-center">
                {(cardBrand === "visa" ||
                  cardBrand === "mastercard" ||
                  cardBrand === "amex" ||
                  cardBrand === "elo") && (
                  <img
                    src={`/icon-credit-card-${cardBrand}.png`}
                    width={60}
                    height={52}
                    alt={`${cardBrand} logo`}
                    className="mr-2"
                  />
                )}
              </div>
            </div>

            <div className="flex flex-col">
              <p className="text-sm text-black font-medium">
                Cartão de Crédito
              </p>
              <p className="text-xs text-black">{cardNumber}</p>
            </div>
          </div>
        </div>

        <img
          src="/svg/icon-arrow-right-2.0.svg"
          width={10}
          height={10}
          alt="Ver detalhes"
          className="text-gray-400"
        />
      </div>
    </div>
  );
}
